export default {
  data () {
    return {
      accountDropdownSettings: {
        title: 'Navbar.MyAccount',
        items: [
          {
            text: 'Navigation.LoyaltyProgram',
            icon: 'price-tag',
            path: 'account-loyalty-program'
          },
          {
            text: 'Order.Orders',
            icon: 'truck',
            path: 'account-orders'
          },
          {
            text: 'Navigation.Memberships',
            icon: 'card',
            path: 'account-memberships'
          },
          {
            text: 'PersonalDetails.PersonalDetails',
            icon: 'edit',
            path: 'account-personal-details'
          }
        ]
      }
    }
  }
}
